import { render, staticRenderFns } from "./TutorialsCollapsible.vue?vue&type=template&id=768a0681&"
import script from "./TutorialsCollapsible.vue?vue&type=script&lang=ts&"
export * from "./TutorialsCollapsible.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports